import FloatingLabel from '@/components/inputs/FloatingLabel'
import LabeledInputSwitch from '@/components/inputs/LabeledInputSwitch'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { MultiSelect } from '@/components/ui/multi-select'
import { Textarea } from '@/components/ui/textarea'
import { useRooms } from '@/hooks'
import { Settings } from '@xeetr/types/models'
import { PlusIcon, Trash2Icon } from 'lucide-react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'

export const TenantCustomCondition = () => {
  const { control } = useFormContext<Settings>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'tenant.settings.customerCustomConditions',
    keyName: 'keyId',
  })
  const { rooms } = useRooms()

  return (
    <>
      {fields.map((item, index) => (
        <Card key={item.keyId}>
          <CardContent className="mt-6 space-y-2">
            <Controller
              name={`tenant.settings.customerCustomConditions.${index}.label`}
              control={control}
              render={({ field }) => (
                <FloatingLabel label={'Anzeige'} className="text-xs">
                  <Input {...field} />
                </FloatingLabel>
              )}
            />
            <Controller
              name={`tenant.settings.customerCustomConditions.${index}.content`}
              control={control}
              render={({ field }) => (
                <FloatingLabel label="Beschreibung" className="text-xs">
                  <Textarea
                    {...field}
                    value={field.value}
                    maxLength={200}
                    rows={5}
                    className="resize-none"
                    placeholder="Beschreibe hier die neue Bedingung..."
                  />
                </FloatingLabel>
              )}
            />
          </CardContent>
          <CardFooter className="flex justify-between">
            <div className="flex w-full gap-2">
              <Controller
                name={`tenant.settings.customerCustomConditions.${index}.roomIds`}
                control={control}
                render={({ field }) => (
                  <FloatingLabel
                    label="Bei welchen ausgewählten Räumen anzeigen"
                    className="text-xs"
                  >
                    <MultiSelect
                      className="min-w-10"
                      emptyState={
                        <div>
                          <p>Es wurden noch keine Kategorien erstellt.</p>
                          <p>
                            <Link to="/settings/rooms" className="text-blue-600 underline">
                              Klicken Sie hier, um welche hinzuzufügen.
                            </Link>
                          </p>
                        </div>
                      }
                      onValueChange={field.onChange}
                      value={field.value}
                      options={rooms.map((room) => ({ label: room.name, value: room.id }))}
                      placeholder="Wähle Räume aus."
                      dropdownPosition="top"
                    />
                  </FloatingLabel>
                )}
              />
              <Controller
                name={`tenant.settings.customerCustomConditions.${index}.required`}
                control={control}
                render={({ field }) => (
                  <LabeledInputSwitch
                    checked={!!field.value}
                    name={field.name}
                    ref={field.ref}
                    label="Bedingung als Pflichtfeld"
                    onValueChange={field.onChange}
                  />
                )}
              />
            </div>

            <Button variant="destructive" onClick={() => remove(index)} icon={<Trash2Icon />} />
          </CardFooter>
        </Card>
      ))}
      <Button
        onClick={() =>
          append({
            id: uuidv4(),
            required: false,
            content: '',
            label: 'Neue Bedingung',
            roomIds: [],
          })
        }
        icon={<PlusIcon />}
      >
        Neue Bedingung
      </Button>
    </>
  )
}
